import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createGeographyFailed, createGeographySuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* createGeography(action) {
  try {
    const url = `${BACKEND_MDS_URL}/geography/geographies`;
    const pool = action.payload;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      const data = yield getBodyJson(response);
      yield put(createGeographySuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(createGeographyFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createGeographyFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
